export enum PaymentStep {
  SELECT_CERTIFICATE = 'SELECT_CERTIFICATE',
  SELECT_PRODUCT = 'SELECT_PRODUCT',
  PAYMENT = 'PAYMENT',
  STEAM = 'STEAM',
  REDIRECT = 'REDIRECT',
}
